export const imageCodes = {
    moon: {
        code: "${merchantId}_tmpl_img_32",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmoon.png?alt=media&token=7cfd3397-02a9-4d3d-b8fc-3c565896d945"
    },

    bg: {
        code: "${merchantId}_tmpl_img_35",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcontant.jpg?alt=media&token=bb3ad1b1-f589-4a93-acd9-dd8d4282debe"
    },
    
}

